import styled from "styled-components";

const Content = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default Content;